// extracted by mini-css-extract-plugin
module.exports = {"contentBlockBody":"ContentBlock-Body--contentBlockBody--1FLVB","default":"ContentBlock-Body--default--2gJE6","large":"ContentBlock-Body--large--3ffj6"};